import React, { useState } from "react";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form } from "react-final-form";
import { Context } from "../../../../_context/Store";
import { getFingerPrint } from "../../../../_helpers/support.services";
import Validator from "../../../../_helpers/validate.schema";
import {
    UiCol,
    UiSingleRow,
} from "../../../_uiComponents/grid-container/GridContainer";

import {
    UiInput,
    UiInputLink,
    UiCheckboxInput,
} from "../../../_uiComponents/form/UiInput";
import { EyeIcon } from "../../../../styles/img/svg/EyeIcon";
import {
    UiButton,
    UiButtonPrimary,
} from "../../../_uiComponents/form/UiButton";
import { forgotPasswordEmailVeryficationRequest } from "../../../../_redux/_actions";
import UiInlineSuccessMessage from "../../../_uiComponents/form/UiInlineSuccessMessage";

const validateSchema = () =>
    yup.object().shape({
        email: yup
            .string()
            .required("Email is required.")
            .email("Email must be a valid email."),
    });

const onValidate = async (values) => {
    return await Validator(values, validateSchema);
};

export default function ForgotPassword(props) {
    const actionDispatch = useDispatch();

    const navigate = useNavigate();

    const submit = async (values, form) => {
        actionDispatch(
            forgotPasswordEmailVeryficationRequest({ ...values, form }),
        );
    };

    return (
        <>
            <UiInlineSuccessMessage />
            <Form
                onSubmit={submit}
                validate={onValidate}
                render={({
                    handleSubmit,
                    hasValidationErrors,
                    valid,
                    ...rest
                }) => {
                    return (
                        <form onSubmit={validateSchema}>
                            <UiInput
                                placeholder="Enter email"
                                type="text"
                                name="email"
                            />
                            <UiSingleRow>
                                <UiCol lg="12">
                                    <div className="sb-auth-forgot-pwd-btn-wr">
                                        <div className="sb-auth-top-wr__btns-cancel">
                                            <UiButtonPrimary
                                                btnName="Cancel"
                                                onClick={() => navigate("/")}
                                            />
                                        </div>
                                        <div className="sb-auth-top-wr__btns-verify sb-auth-top-wr-verify-btn">
                                            <UiButtonPrimary
                                                btnName="Verify"
                                                onClick={handleSubmit}
                                            />
                                        </div>
                                    </div>
                                </UiCol>
                            </UiSingleRow>
                        </form>
                    );
                }}
            />
        </>
    );
}
